import { default as CircleStyle } from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import Text from 'ol/style/Text';

const PARCEL_BASE_STROKE = new Stroke({
  color: '#000',
  width: 2,
});

const getParcelLabelStyle = (feature) =>
  new Style({
    text: new Text({
      font: 'italic 11px Calibri,sans-serif',
      overflow: true,
      fill: new Fill({
        color: '#000',
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 3,
      }),
      text: feature.get('numero'),
    }),
  });

export const getParcelStyle = (feature, view) => {
  const styles = [
    new Style({
      stroke: PARCEL_BASE_STROKE,
      fill: new Fill({
        color: 'transparent',
      }),
    }),
  ];

  if (view.getZoom() > 17) {
    styles.push(getParcelLabelStyle(feature));
  }

  return styles;
};

export const getSelectedParcelStyle = (feature) => {
  return [
    new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.6)',
      }),
      stroke: PARCEL_BASE_STROKE,
    }),
    getParcelLabelStyle(feature),
  ];
};

export const getValidatedParcelStyle = (feature) => {
  return [
    new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.6)',
      }),
      stroke: new Stroke({
        color: 'rgb(206, 0, 48)',
        width: 2,
      }),
    }),
    getParcelLabelStyle(feature),
  ];
};

export const getSelectValidatedParcelleStyle = (feature) => {
  return [
    new Style({
      fill: new Fill({
        color: 'rgb(206, 0, 48, 0.6)',
      }),
      stroke: new Stroke({
        color: 'rgb(206, 0, 48)',
        width: 2,
      }),
    }),
    getParcelLabelStyle(feature),
  ];
};

export const highlightStyle = new Style({
  fill: new Fill({
    color: 'rgba(255, 255, 255, 0.2)',
  }),
  stroke: new Stroke({
    color: '#CE0030',
    width: 2,
  }),
  image: new CircleStyle({
    radius: 7,
    fill: new Fill({
      color: '#CE0030',
    }),
  }),
});

export const measureDrawStyle = new Style({
  fill: new Fill({
    color: 'rgba(255, 255, 255, 0.2)',
  }),
  stroke: new Stroke({
    color: '#000',
    lineDash: [10, 10],
    width: 2,
  }),
  image: new CircleStyle({
    radius: 5,
    stroke: new Stroke({
      color: '#000',
    }),
    fill: new Fill({
      color: 'rgba(255, 255, 255, 0.2)',
    }),
  }),
});
